import { getBrandsFromApi } from '/@/hooks/products';
import { getLocationsFromApi } from '/@/hooks/session';
import { createAction } from '../utils';

export const fetchBrands = createAction('BRANDS:FETCH', async () => {
    const brands = await getBrandsFromApi({ page: 1, pageSize: 10000 });

    return brands.results;
});

export const fetchLocations = createAction('LOCATIONS:FETCH', async () => {
    const locations = await getLocationsFromApi({ pageSize: 1000, page: 1, level: 0 });
    return locations?.results;
});
